import React, {Component} from 'react';
import Options from './Options';
import Feedback from './Feedback';
import {StepCheckWrapper} from './styles';
import {inject, observer} from 'mobx-react';
import MultipleOptionsViewer from './MultipleOptions/MultipleOptionsViewer';
import BinaryOptions from './BinaryOptions';

@inject('store')
@observer
class StepCheckToolbar extends Component {
  render() {
    const {stepId, isDesktop, stepIndex, isMobile, checklistTemplate, store, disabledOptionsIds} = this.props;
    const {developmentFeatureFlags} = store.platform;

    const onClickOption = optionId => {
      const params = {optionId};
      const {
        checklist: {updateChecklist}
      } = store;

      // Support for old checklists
      if (checklistTemplate.type === 'BINARY') {
        const yesOption = checklistTemplate.options.find(option => option.value === 1);
        if (optionId === yesOption.id) {
          params.checked = true;
          params.unchecked = false;
        } else {
          params.checked = false;
          params.unchecked = true;
        }
      }

      updateChecklist(stepId, params);
    };

    return (
      <StepCheckWrapper>
        {developmentFeatureFlags.checklistScoring ? (
          checklistTemplate.type === 'BINARY' ? (
            <BinaryOptions
              options={checklistTemplate.options}
              onClickOption={onClickOption}
              selected={store.checklist.checklist[stepId]?.optionId}
              testIdPrefix={`binary-options-${stepIndex}`}
            />
          ) : (
            <MultipleOptionsViewer
              options={checklistTemplate.options}
              onClickOption={onClickOption}
              selected={store.checklist.checklist[stepId]?.optionId}
              testIdPrefix={`score-options-${stepIndex}`}
              disabledOptionsIds={disabledOptionsIds}
            />
          )
        ) : (
          <Options stepId={stepId} stepIndex={stepIndex} isDesktop={isDesktop} isMobile={isMobile} />
        )}

        <Feedback stepId={stepId} stepIndex={stepIndex} isDesktop={isDesktop} isMobile={isMobile} />
      </StepCheckWrapper>
    );
  }
}

export default StepCheckToolbar;
